import { render, staticRenderFns } from "./HubInfo.vue?vue&type=template&id=0c8a87a6&scoped=true&"
import script from "./HubInfo.vue?vue&type=script&lang=js&"
export * from "./HubInfo.vue?vue&type=script&lang=js&"
import style0 from "./HubInfo.vue?vue&type=style&index=0&id=0c8a87a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a87a6",
  null
  
)

export default component.exports